'use strict';

var core = require('@capacitor/core');

const FileOpener = core.registerPlugin('FileOpener', {
    web: () => Promise.resolve().then(function () { return web; }).then(m => new m.FileOpenerWeb()),
});

class FileOpenerWeb extends core.WebPlugin {
    async openFile(options) {
        if (!options.blob) {
            throw new Error(FileOpenerWeb.ERROR_BLOB_MISSING);
        }
        const objectUrl = URL.createObjectURL(options.blob);
        window.open(objectUrl, '_blank');
    }
}
FileOpenerWeb.ERROR_BLOB_MISSING = 'blob must be provided.';

var web = /*#__PURE__*/Object.freeze({
    __proto__: null,
    FileOpenerWeb: FileOpenerWeb
});

exports.FileOpener = FileOpener;
//# sourceMappingURL=plugin.cjs.js.map
